// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "dirty": false,
    "raw": "v0.1.0-0-g23f0dd9",
    "hash": "g23f0dd9",
    "distance": 0,
    "tag": "v0.1.0",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v0.1.0",
        "major": 0,
        "minor": 1,
        "patch": 0,
        "prerelease": [],
        "build": [],
        "version": "0.1.0"
    },
    "suffix": "0-g23f0dd9",
    "semverString": "0.1.0",
    "version": "0.1.0",
    "versionDateTime": "2026-11-05T09:49:55.574Z"
};
